import React from 'react'

function EXPScaler(props) {
	return (
		<div>
			<h1>EXP Scaler</h1>
			<p>Work in progress</p>
		</div>
	)
}

export default EXPScaler
